import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import LoadingPage from '../modules/consulta/components/LoadingPage';
import Logout from './../modules/consulta/pages/auth/Logout';
import { ProtectedRoute } from '../shared/components';
import Statistics from "../modules/consulta/pages/Statistics";
import StatisticsDetails from "../modules/consulta/pages/Statistics/StatisticsDetails";
import ApplicationProviders from '../shared/contexts/ApplicationProviders';
import RestrictCollection from '../modules/consulta/pages/auth/RestrictCollection';
import RestrictedAccess from '../modules/consulta/components/DadosAcervo/RestrictedAccess';
import DadosAcervoBiblioteca from '../modules/consulta/pages/home/DadosAcervoBiblioteca';
import AppExternalPluginLoader from '../shared/components/AppExternalPluginLoader';
const CollectionData = React.lazy(() => import('../modules/consulta/components/DadosAcervo/CollectionData'));
const Home = React.lazy(() => import('./../modules/consulta/pages/home/Home'));
const Login = React.lazy(() => import('./../modules/consulta/pages/auth/Login'));
const PearsonAuthPage = React.lazy(() => import('./../modules/consulta/pages/auth/PearsonAuthPage'));
const DadosAutoridadeV2 = React.lazy(() => import('./../modules/consulta/pages/home/DadosAutoridadeV2'));
const Cesta = React.lazy(() => import('./../modules/consulta/pages/home/Cesta'));
const ErrorPage = React.lazy(() => import('./../modules/consulta/components/ErrorPage'));
const MeuPergamum = React.lazy(() => import('../modules/meupergamum'));
const PergamumRedireciona = React.lazy(() => import('./../modules/consulta/pages/auth/PergamumRedirect'));
const OAuthResponse = React.lazy(() => import('../modules/consulta/pages/auth/OAuthResponse'));
const GrupoA = React.lazy(() => import('./../modules/consulta/pages/auth/GrupoA'));
const AppLayers = React.lazy(() => import('./../modules/meupergamum/pages/AppLayers'));
const SamlResponse = React.lazy(() => import('./../modules/consulta/pages/auth/SamlResponse'));
const AlertaBibliografico = React.lazy(() => import('../modules/consulta/pages/AlertaBibliografico'));
const NadaConstaValidateQRCode = React.lazy(() => import('../modules/consulta/pages/NadaConstaValidateQrCode'));

//Pergamum kids
const HomePergamumKids = React.lazy(() =>
    import('../modules/consulta/pergamum_kids/pages/Home'),
);

const AccessibilityContextProvider = React.lazy(() =>
    import('../modules/consulta-acessibilidade/contexts/AccessibilityContext'),
);

const AccessibilitySearchAbout = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchAbout'),
);
const AccessibilitySearch = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearch'),
);
const AccessibilitySearchResults = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchResults'),
);
const AccessibilitySearchPreResult = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchPreResult'),
);

const AccessibilitySearchFilters = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchFilters'),
);

const AccessibilitySearchDetails = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchDetails'),
);

const AccessibilitySearchFaq = React.lazy(() =>
    import('../modules/consulta-acessibilidade/faq/AccessibilitySearchFaq'),
);

const AccessibilitySearchLibraries = React.lazy(() =>
    import("../modules/consulta-acessibilidade/AccessibilitySearchLibraries"),
);


const Routers = () => (
    <Suspense fallback={<LoadingPage />}>
        <BrowserRouter 
            basename={process.env.REACT_APP_PREFIX}
            future={{
                v7_relativeSplatPath: true,
                v7_startTransition: true
            }}
        >
           <ApplicationProviders>
               <Routes>
                   <Route path="/" element={<Home />} />
                   <Route path="/login" element={<Login />} />
                   <Route path="/sair" element={<Logout />} />
                   <Route path="/pergamum_redireciona" element={<PergamumRedireciona />} />
                   <Route path="/oauth-response" element={<OAuthResponse />} />
                   <Route path="/saml-response" element={<SamlResponse />} />
                   <Route path="/grupoa" element={<GrupoA />} />
                   <Route path="/alerta-bibliografico" element={<AlertaBibliografico />} />
                   {/* Rotas para a pesquisa de acessibilidade */}
                   <Route path="/pesquisa_acessibilidade/*" element={
                       <AccessibilityContextProvider>
                           <Routes>
                               <Route
                                   index
                                   element={<AccessibilitySearch />}
                               />
                               <Route
                                   path="sobre"
                                   element={<AccessibilitySearchAbout />}
                               />

                               <Route
                                   path="bibliotecas/:codAcervo"
                                   element={<AccessibilitySearchLibraries />}
                               />
                               <Route
                                   path="resultados"
                                   element={<AccessibilitySearchResults />}
                               />
                               <Route
                                   path="pre-resultado"
                                   element={<AccessibilitySearchPreResult />}
                               />
                               <Route
                                   path="filtros"
                                   element={<AccessibilitySearchFilters />}
                               />
                               <Route
                                   path="detalhes/:codAcervo/:codBiblioteca?"
                                   element={<AccessibilitySearchDetails />}
                               />
                               <Route
                                   path="duvidas-frequentes"
                                   element={<AccessibilitySearchFaq />}
                               />
                               <Route
                                   path="*"
                                   element={<ErrorPage />}
                               />
                           </Routes>
                       </AccessibilityContextProvider>
                   } />
                   {/* Rotas para a pesquisa de acessibilidade */}

                   {/* ROTAS KIDS */}
                   <Route path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca" element={<HomePergamumKids extras={false} showDadosAcervo acervoCompleto />} />
                   <Route path="/catalogos/:prefix/acervo/simple/:codAcervo/:codBiblioteca" element={<HomePergamumKids extras={false} showDadosAcervo />} />

                   {/*<Route path="/pergamum-kids/:codBiblioteca?/:codCategoria?" element={<HomePergamumKids />} />*/}

                   <Route path="/catalogos/:prefix/:codBiblioteca?/:codCategoria?" element={<HomePergamumKids />} />

                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/referencia"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'33'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/marc"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'36'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/exemplares"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'30'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/dublin-core"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'115'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/reserva"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'18'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/solicitacao-emprestimo"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'75'}
                           />
                       }
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/colecao-kardex"
                       element={
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'32'}
                           />
                       }
                   />
                   {/* ROTAS KIDS */}

                   {/* ROTAS ESTATISTICAS */}
                   <Route path="/estatistica" element={<Statistics />} />
                   <Route path="/estatistica/:route" element={<StatisticsDetails />} />
                   {/* ROTAS ESTATISTICAS */}

                   {/* Rota para fazer a autenticação para ebooks da pearson */}
                   <Route
                       path="/pearson"
                       element={<PearsonAuthPage />}
                   />
                   {/* Cesta */}
                   <Route
                       path="/cesta"
                       element={<Cesta />}
                   />
                   {/* Módulo Meu Pergamum */}
                   <Route path="/meupergamum/app" element={<AppLayers />} />
                   <Route path="/meupergamum/*" element={<ProtectedRoute component={MeuPergamum} />} />
                   {/* Alterar rotas conforme navega no menu:  */}
                   <Route
                       path="/:guia"
                       element={<Home />}
                   />
                   {/* Dados do acervo: */}
                   <Route
                       path="/acesso-restrito/:codAcervo"
                       element={<RestrictedAccess />}
                   />
                   <Route
                       path="/acervo/:codAcervo/restrito"
                       element={<RestrictCollection />}
                   />
                   <Route
                       path="/acervo/:codAcervo"
                       element={<CollectionData />}
                   />
                   <Route
                       path="/acervo-v2/:codAcervo"
                       element={<CollectionData />}
                   />
                   <Route path="/acervo/:codAcervo/referencia" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/marc" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/ris" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/exemplares" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/dublin-core" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/reserva" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/solicitacao-emprestimo" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/solicitacao-emprestimo-delivery" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/colecao-kardex" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/sumarios" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/sumarios-livros" element={<CollectionData />} />
                   <Route path="/acervo/:codAcervo/dados-estatisticos" element={<CollectionData />} />
                   <Route
                        path="/biblioteca/:codAcervo"
                        element={
                            <DadosAcervoBiblioteca />
                        }
                    />
                   {/* Dados da Autoridade */}
                   <Route
                       path="/autoridade/:codAutoridade"
                       element={
                           <DadosAutoridadeV2 linkCurrent={'def'} />
                       }
                   />
                   <Route
                       path="/autoridade/:codAutoridade/marc"
                       element={
                           <DadosAutoridadeV2 linkCurrent={'marc'} />
                       }
                   />
                   <Route path="/acervo/:codAcervo/acervo-fechado" element={<CollectionData />} />

                   <Route
                       path="/nada-consta-validate-qrcode/:cod/:valid/:motivo"
                       element={
                           <NadaConstaValidateQRCode />
                       }
                   />

                   <Route path="*" element={<ErrorPage />} />
               </Routes>
               <AppExternalPluginLoader />
           </ApplicationProviders>
        </BrowserRouter>
    </Suspense>
);

export default Routers;
